import { HeatingGroundHeatPumpParameters } from '../../generated/graphql'
import { EnergyType } from '../EnergyFlow'
import { mapValueBasedOnMaxPower } from './util/value-mapper'
import {
  createHourlyFromEnvironment,
  createHourlyProvided,
  createHourlyRequirement,
  HourlyEnergyFlow,
} from '../HourlyEnergyFlow'
import {
  SingleTypeHourlyVariables,
  SingleTypeProvider,
} from './common/SingleTypeProvider'

/**
 * Converts electricity to heating with a limited power.
 */
export class HeatingGroundHeatPumpProvider extends SingleTypeProvider<HeatingGroundHeatPumpParameters> {
  public readonly providedEnergyTypes = [EnergyType.Heating]

  protected provideForHour({
    remainingDemand,
  }: SingleTypeHourlyVariables): HourlyEnergyFlow[] {
    const { cop } = this.parameters

    const energy = mapValueBasedOnMaxPower(
      remainingDemand.value,
      this.parameters.maxPower,
    )

    const provided = createHourlyProvided(
      remainingDemand.demandId,
      remainingDemand.energyType,
      energy,
    )

    const requiredConsumption = createHourlyRequirement(
      provided.demandId,
      EnergyType.Electricity,
      provided.value / cop,
    )

    const fromEnvironment = createHourlyFromEnvironment(
      provided.demandId,
      provided.energyType,
      provided.value - provided.value / cop,
    )

    return [provided, requiredConsumption, fromEnvironment]
  }
}
